import { Calendar } from "./Calendar";
export class TermCalendar {
    _termNumber;
    _calendar;
    active = true;
    jsTermNumber;
    constructor(params) {
        this.termNumber = params.termNumber;
        this.calendar = params.calendar;
        if (params.active !== undefined) {
            this.active = params.active;
        }
    }
    get termNumber() {
        return this._termNumber;
    }
    set termNumber(value) {
        this._termNumber = value;
        this.jsTermNumber = value;
    }
    get calendar() {
        return this._calendar;
    }
    set calendar(value) {
        if (value instanceof Calendar) {
            this._calendar = value;
        }
        else {
            this._calendar = new Calendar(value);
        }
    }
    updateModelValues() {
        this.termNumber = this.jsTermNumber;
    }
    updateJsValues() {
        this.jsTermNumber = this.termNumber;
    }
    get json() {
        return {
            termNumber: this.termNumber,
            calendar: this.calendar.calendarType,
            active: this.active,
        };
    }
}
